// extracted by mini-css-extract-plugin
export default {"activeMarkerIcon":"active-marker-badge-module__activeMarkerIcon--taFAp","activeMarker":"active-marker-badge-module__activeMarker--Nv4Ml"};